<template>
  <div style="margin-top: 113px" v-if="myUser">
    <v-container>
      <v-card>
        <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
          <b>{{ snackBarText }} </b>
        </v-snackbar>
        <div class="my-2">
          <v-btn small class="mx-6 my-6" fab dark color="warning" v-on:click="$router.go(-1)">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          Employee {{ myUser.firstName }} {{ myUser.lastName }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="myUser.firstName" label="First Name" disabled></v-text-field>
            <v-text-field v-model="myUser.lastName" label="Last Name" disabled></v-text-field>
            <v-text-field v-model="myUser.login" label="Login" disabled></v-text-field>
            <v-text-field v-model="myUser.jobTitle" label="Job title"></v-text-field>
            <v-select v-model="myUser.businessUnit.code" :items="refBusinessUnits" label="Business Unit" item-text="label"
              item-value="code" disabled></v-select>
            <v-select v-model="myUser.groupFunction.code" :items="refGroupFunctions"
              @change="refSubGroupFunctionsUpdate()" label="Group function" item-text="label"
              item-value="code"></v-select>
            <v-select v-model="myUser.locationCountry.code" :items="refLocationCountry" label="Location Country"
              item-text="label" item-value="code" disabled></v-select>
            <v-text-field v-model="myUser.locationCity" label="Location City" disabled></v-text-field>
            <v-select v-model="myUser.employers.code" :items="refEmployer" label="Employer" item-text="label"
              item-value="code" disabled></v-select>

            Strong line manager : {{ myUser.slm.firstName }}
            {{ myUser.slm.lastName }}
            <div v-if="myUser.slm.jobTitle != '' && myUser.slm.jobTitle != undefined
              ">
              ({{ myUser.slm.jobTitle }})
            </div>
            <v-divider></v-divider>
            <v-autocomplete ref="slManagerField" v-model="slmanager" :items="itemsForSLM" :loading="isLoadingForSLM"
              :search-input.sync="searchForSLM" color="white" hide-no-data hide-selected item-text="Description"
              item-value="SLM" label="Strong line manager" placeholder="Start typing to search"
              prepend-icon="mdi-database-search" return-object @input="handleSelection"
              :rules="slManagerValidationRules"></v-autocomplete>
            <v-btn depressed small color="primary" @click="clearSLM()" class="ma-4">
              Reset strong line manager
            </v-btn>
            <v-divider></v-divider>
            Dotted line manager : {{ myUser.dlm.firstName }}
            {{ myUser.dlm.lastName }}
            <div v-if="myUser.dlm.jobTitle != '' && myUser.dlm.jobTitle != undefined
              ">
              ({{ myUser.dlm.jobTitle }})
            </div>
            <v-divider></v-divider>
            <v-autocomplete ref="dlManagerField" v-model="dlmanager" :items="itemsForDLM" :loading="isLoadingForDLM"
              :search-input.sync="searchForDLM" color="white" hide-no-data hide-selected item-text="Description"
              item-value="DLM" label="Dotted line manager" placeholder="Start typing to search"
              prepend-icon="mdi-database-search" return-object @input="handleSelection"
              :rules="dlManagerValidationRules"></v-autocomplete>
            <v-btn depressed small color="primary" @click="clearDLM()" class="ma-4">
              Reset dotted line manager
            </v-btn>
            <br />
            Delegate : {{ myUser.delegate.firstName }}
            {{ myUser.delegate.lastName }}
            <div v-if="myUser.delegate.jobTitle != '' &&
              myUser.delegate.jobTitle != undefined
              ">
              ({{ myUser.delegate.jobTitle }})
            </div>
            <v-divider></v-divider>
            <v-checkbox v-model="myUser.active" label="Active" disabled></v-checkbox>
            <v-divider></v-divider>
            <v-btn color="success" class="mr-4" @click="validate">
              Validate
            </v-btn>
            <v-btn color="warning" @click="resetForm">
              Reset
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"
            ><span> Update review for employee </span></v-card-title
          >
          <v-card-text>
            <v-container>
              <span>
                Historic reviews will now be transferred to the new manager. Do you also wish to transfer the current review?</span
              >
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                updateCurrentReview = false;
                dialog = false;
                validateWithDialog();
              "
              >No</v-btn
            >
            <v-btn
              color="orange darken-1"
              text
              @click="
                updateCurrentReview = true;
                dialog = false;
                validateWithDialog();
              "
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "HRUserUpdate",
  data() {
    return {
      // [START] Data for autocomplete search
      slManagerValidationRules: [
        (v) => {
          console.log(v);
          if ((this.slmanager && this.dlmanager && this.slmanager === this.dlmanager) ||
            this.slmanager == this.myUser.dlm.firstName + ' ' + this.myUser.dlm.lastName) {
            return "SL Manager and DL Manager can't be the same person";
          }
          return true;
        },
        (v) => {
          console.log(v);
          if (this.slManagerValid == false) {
            return "The new manager cannot have the user as manager";
          }
          return true;
        }
      ],
      dlManagerValidationRules: [
        (v) => {
          console.log(v);
          if ((this.slmanager && this.dlmanager && this.slmanager === this.dlmanager) ||
            this.dlmanager == this.myUser.slm.firstName + ' ' + this.myUser.slm.lastName) {

            return "SL Manager and DL Manager can't be the same person";
          }
          return true;
        },
        (v) => {
          console.log(v);
          if (!this.dlManagerValid) {
            return "The new manager cannot have the user as manager";
          }
          return true;
        }
      ],
      managerToDelete: "",
      slManagerValid: true,
      dlManagerValid: true,
      descriptionLimit: 60,
      entriesForSLM: [],
      entriesForDLM: [],
      myUser: null,
      managerChanged: false,
      isLoadingForSLM: false,
      isLoadingForDLM: false,
      slmanager: null,
      dlmanager: null,
      searchForSLM: null,
      searchForDLM: null,
      countForSLM: 0,
      updateReview: false,
      dialog: false,
      countForDLM: 0,
      // [END] Data for autocomplete search
      findByName: "",
      refBusinessUnits: [],
      refGroupFunctions: [],
      refLocationCountry: [],
      refEmployer: [],
      refSubGroupFunctions: [],
      refSubGroupFunctionsCurrent: [],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,

      updateCurrentReview: false,
      reset: false,
      transferPastReviews: false,
    };
  },
  computed: {
    itemsForSLM() {
      return this.entriesForSLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
    itemsForDLM() {
      return this.entriesForDLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
  },
  watch: {
    slManagerValid() {
      if (this.$refs.slManagerField) {
        this.$refs.slManagerField.validate();
      }
    },
    dlManagerValid() {
      if (this.$refs.dlManagerField) {
        this.$refs.dlManagerField.validate();
      }
    },
    searchForSLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForSLM) return;

      this.isLoadingForSLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForSLM = res.data.length;
          this.entriesForSLM = res.data;
        })
        .finally(() => (this.isLoadingForSLM = false));
    },
    searchForDLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForDLM) return;

      this.isLoadingForDLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForDLM = res.data.length;
          this.entriesForDLM = res.data;
        })
        .finally(() => (this.isLoadingForDLM = false));
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    async handleSelection() {
      var managerType;
      if (this.entriesForSLM[0]) {
        managerType = "slm"
      }
      else if (this.entriesForDLM[0]) {
        managerType = "dlm"
      }

      await this.canBeManager(managerType);
    },
    selectedSLM(count, list) {
      let selectedSLM = "";
      for (var i = 0; i < count; i++) {
        selectedSLM = list[i].firstName + " " + list[i].lastName;
        if (selectedSLM == this.searchForSLM) {
          return (list[0] = list[i]);
        }
      }
    },
    selectedDLM(count, list) {
      let selectedDLM = "";
      for (var i = 0; i < count; i++) {
        selectedDLM = list[i].firstName + " " + list[i].lastName;
        if (selectedDLM == this.searchForDLM) {
          return (list[0] = list[i]);
        }
      }
    },
    init: function () {
      this.loadData();
    },
    loadRefs: function () {
      this.fillBusinessUnits();
      this.fillGroupFunctions();
      this.fillLocationCountrys();
      this.fillEmployers();
    },
    clearSLM() {
      this.reset = true;
      this.transferPastReviews = false;
      this.slmanager = null;
      this.myUser.slm.id = null;
      this.entriesForSLM = [];

      this.entriesForDLM = [this.myUser.dlm];
      this.managerChanged = true;
      this.managerToDelete = "slm";
      this.validate();
    },
    clearDLM() {
      this.reset = true;
      this.transferPastReviews = false;
      this.dlmanager = null;
      this.myUser.dlm.id = null;
      this.entriesForDLM = [];

      this.entriesForSLM = [this.myUser.slm];
      this.managerChanged = true;
      this.managerToDelete = "dlm";
      this.validate();
    },
    async canBeManager(managerType) {
      var myHeaders = new Headers();
      var idMan;
      if (managerType == "slm") {
        const selectedEntry = this.entriesForSLM.find(
          entry => entry.firstName + " " + entry.lastName === this.slmanager
        );
        if (!selectedEntry) {
          console.error("Selected entry not found!");
          return;
        }
        idMan = selectedEntry.id;
      }
      else {
        const selectedEntry = this.entriesForDLM.find(
          entry => entry.firstName + " " + entry.lastName === this.dlmanager
        );
        if (!selectedEntry) {
          console.error("Selected entry not found!");
          return;
        }
        idMan = selectedEntry.id;
      }
      myHeaders.append("Content-Type", "application/json");
      let apiUrl = `${process.env.VUE_APP_ROOT_API_PATH}api/canBeAdminOf?idUser=${this.myUser.id}&idMan=${idMan}`;
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        });

        if (response.status == "200" || response.status == "201") {
          const json = await response.json();
          var data = json.data;
          if (managerType === "slm") {
            this.slManagerValid = data;
          } else {
            this.dlManagerValid = data;
          }
          return data;
        } else {
          this.message = "An error happened, please try again later";
          this.messageType = "error";
          this.showMessage = true;
          return false; // Vous pouvez renvoyer false ou undefined ici, selon votre besoin
        }
      } catch (error) {
        this.message = "An error occurs, please try again later";
        this.messageType = "error";
        this.showMessage = true;
        return false;
      }
    },
    fillBusinessUnits: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/businessUnits", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refBusinessUnits = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillGroupFunctions: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/groupFunctions", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refGroupFunctions = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillLocationCountrys: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/locationCountrys", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLocationCountry = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillEmployers: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/employers", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refEmployer = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    validate: function () {
      if (this.entriesForSLM[0] && this.entriesForDLM[0] && this.entriesForSLM[0].id === this.entriesForDLM[0].id
        || this.dlmanager == this.myUser.slm.firstName + ' ' + this.myUser.slm.lastName
        || this.slmanager == this.myUser.dlm.firstName + ' ' + this.myUser.dlm.lastName) {
        this.snackbar = true;
        this.snackBarText = "SL Manager and DL Manager can’t be the same person";
        this.snackBarColor = "error";
        return;
      }
      if (!this.slManagerValid || !this.dlManagerValid) {
        this.snackbar = true;
        this.snackBarText = "The new manager cannot have the user as manager";
        this.snackBarColor = "error";
        return;
      }
      if (this.entriesForSLM[0]) {
        this.selectedSLM(this.countForSLM, this.entriesForSLM);
        this.myUser.slm = this.entriesForSLM[0];
        this.managerChanged = true;
      }
      if (this.entriesForDLM[0]) {
        this.selectedDLM(this.countForDLM, this.entriesForDLM);
        this.myUser.dlm = this.entriesForDLM[0];
        this.managerChanged = true;
      }
      if (this.managerChanged) {
        this.dialog = true;
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var myMethod = "put";

      let newDlManagerId = (this.entriesForDLM && this.entriesForDLM[0] && this.entriesForDLM[0].id) ? this.entriesForDLM[0].id : -1;
      let newSlManagerId = (this.entriesForSLM && this.entriesForSLM[0] && this.entriesForSLM[0].id) ? this.entriesForSLM[0].id : -1;


      let apiUrl = `${process.env.VUE_APP_ROOT_API_PATH}api/users?updateCurrentReview=${this.updateCurrentReview}&newDlManagerId=${newDlManagerId}
      &newSlManagerId=${newSlManagerId}&managerToDelete=${this.managerToDelete}`;

      fetch(apiUrl, {
        method: myMethod,
        credentials: "include",
        headers: myHeaders,
        body: JSON.stringify(this.myUser),
      }).then((response) => {
        this.snackbar = true;
        this.managerToDelete = "";
        if (response.status >= 200 && response.status < 300) {
          this.snackBarText = "Saved successfully";
          this.snackBarColor = "success";
          this.init();
        } else {
          this.snackBarText = "Something went wrong";
          this.snackBarColor = "error";
          this.init();
        }
      });
    },
    validateWithDialog: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var myMethod = "put";

      let newDlManagerId = (this.entriesForDLM && this.entriesForDLM[0] && this.entriesForDLM[0].id) ? this.entriesForDLM[0].id : -1;
      let newSlManagerId = (this.entriesForSLM && this.entriesForSLM[0] && this.entriesForSLM[0].id) ? this.entriesForSLM[0].id : -1;

      let apiUrl = `${process.env.VUE_APP_ROOT_API_PATH}api/users?updateCurrentReview=${this.updateCurrentReview}&newDlManagerId=${newDlManagerId}
      &newSlManagerId=${newSlManagerId}&managerToDelete=${this.managerToDelete}`;


      fetch(
        apiUrl,
        {
          method: myMethod,
          credentials: "include",
          headers: myHeaders,
          body: JSON.stringify(this.myUser),
        }
      ).then((response) => {
        this.snackbar = true;
        this.managerToDelete = "";
        if (response.status >= 200 && response.status < 300) {
          this.snackBarText = "Saved successfully";
          this.snackBarColor = "success";
          this.init();
        } else {
          this.snackBarText = "Something went wrong";
          this.snackBarColor = "error";
          this.init();
        }
      });
    },
    connectAs: function () {
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
        "api/secure/changeAuth/" +
        this.myUser.id,
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then((response) => {
          if (response.status == "200") {
            return response.json();
          } else {
            this.$store.dispatch("auth/disconnect");
          }
        })
        .then((json) => {
          if (json) {
            this.$store.dispatch("auth/connect", {
              login: json.data.login,
              firstName: json.data.firstName,
              lastName: json.data.lastName,
              roles: json.data.roles,
            });
            this.$router.push("/");
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
    resetForm: function () {
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
    },
    refSubGroupFunctionsUpdate: function () {
      var codegf = this.myUser.groupFunction.code;
      this.refSubGroupFunctionsCurrent = [];
      this.refSubGroupFunctions.forEach((element) => {
        if (element.refGroupFunctionDto.code == codegf) {
          this.refSubGroupFunctionsCurrent.push(element);
        }
      });
    },
    loadData: function () {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
        "api/users/" +
        this.$route.params.id,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.myUser = json.data;
          this.loadRefs();
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
  },
};
</script>
